import { debounce } from 'throttle-debounce';

const $ = jQuery;

$('#search').bind('keypress keydown keyup', function(e){
  if(e.keyCode == 13) { e.preventDefault(); }
});

export function ajax_search() {

  $(document).on('keyup', 'form.search-form', debounce(250, function (event) {
    event.preventDefault();

    var query = this.s.value;

    if (query.length >= 3) {

      var $content = $('#content');

      $content.addClass('loading');

      wp.ajax
      .post('load_search_results', {
        s:query
      })
      .then(function(html) {
        console.log($content.html( html ));
        $content.html( html );
      })
      .fail(function(response) {
        console.error(response);
      })
      .always(function(){
        $content.removeClass('loading');
      });
    }
  }));
}